// 奶水乐园 - 关于我们模拟数据
export const aboutData = {
  brandName: "奶水乐园",
  slogan: "每一位妈妈都值得被温柔以待",
  intro: `奶水乐园成立于2024年，是国内领先的母乳喂养知识分享平台。我们深切理解每一位哺乳期妈妈在喂养过程中面临的各种挑战与困惑，因此汇聚了专业的母乳喂养指导师、营养师、妇产科医生以及众多经验丰富的妈妈，共同打造了这个温馨、专业、实用的知识乐园。

我们的使命是：让每一位妈妈都能获取科学、全面的母乳喂养知识，轻松实现纯母乳喂养，让宝宝在生命最初的阶段获得最珍贵的天然营养。

奶水乐园的所有内容均经过专业人士审核，确保信息的准确性和时效性。我们不仅提供理论知识，更注重实操经验的分享，让每一位妈妈都能在这里找到适合自己的喂养方案。`,
  features: [
    {
      icon: "ri-shield-check-line",
      title: "专业权威",
      description: "所有内容均由持证哺乳顾问、妇产科专家及营养师共同审核，确保知识准确可靠。",
    },
    {
      icon: "ri-heart-line",
      title: "温暖陪伴",
      description: "我们深知哺乳之路不易，用温暖有爱的文字和贴心的实用建议陪伴每一位妈妈。",
    },
    {
      icon: "ri-lightbulb-line",
      title: "实操性强",
      description: "拒绝空洞理论，每一篇文章都包含可立即上手的实用技巧和方案。",
    },
    {
      icon: "ri-group-line",
      title: "经验分享",
      description: "汇集成千上万位成功母乳喂养妈妈的真实经验，让你少走弯路。",
    },
  ],
  stats: [
    { value: "50万+", label: "累计服务妈妈" },
    { value: "500+", label: "原创文章" },
    { value: "98%", label: "用户好评率" },
    { value: "30+", label: "认证专家" },
  ],
  contact: {
    address: "北京市朝阳区建国路88号SOHO现代城A座1208室",
    phone: "400-888-6688",
    email: "hello@naishuileyuan.com",
    workHours: "周一至周五 9:00 - 18:00",
  },
};

export const testimonials = [
  {
    name: "小敏妈妈",
    avatar: "https://readdy.ai/api/search-image?query=warm%20soft%20portrait%20of%20young%20Asian%20woman%20smiling%20gently%2C%20minimal%20studio%20photography%20with%20soft%20natural%20lighting%2C%20neutral%20cream%20background%2C%20clean%20composition&width=120&height=120&seq=avatar-01&orientation=squarish",
    role: "新手妈妈 · 宝宝6个月",
    content: "作为一个新手妈妈，曾经因为奶水不足差点放弃母乳喂养。偶然发现奶水乐园，按照上面的追奶方法坚持了一周，奶水量真的上来了！现在宝宝6个月，纯母乳喂养，白白胖胖的，真的太感谢了！",
  },
  {
    name: "思雨妈妈",
    avatar: "https://readdy.ai/api/search-image?query=tender%20portrait%20of%20young%20Asian%20woman%20with%20warm%20expression%2C%20soft%20lighting%2C%20cream%20background%2C%20gentle%20and%20natural%20pose&width=120&height=120&seq=avatar-02&orientation=squarish",
    role: "二胎妈妈 · 宝宝3个月",
    content: "二胎的时候遇到了和老大完全不同的问题，乳腺炎反反复复。在奶水乐园学到了很多预防和护理的方法，还按着催奶食谱给家人做，效果真的很棒。这里的食谱既好吃又下奶，连老公都赞不绝口！",
  },
  {
    name: "雅琪妈妈",
    avatar: "https://readdy.ai/api/search-image?query=soft%20portrait%20of%20young%20Asian%20mother%20with%20gentle%20smile%2C%20warm%20natural%20light%2C%20creamy%20neutral%20background%2C%20minimalist%20style&width=120&height=120&seq=avatar-03&orientation=squarish",
    role: "职场背奶妈妈 · 宝宝8个月",
    content: "产假结束后重返职场，背奶成了大难题。多亏了奶水乐园的母乳储存指南和职场背奶攻略，现在每天都能给家里带回去充足的母乳。效率高、方法对，真的帮了大忙！",
  },
];